import script from "./RoomOtherSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./RoomOtherSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./RoomOtherSkeleton.vue?vue&type=style&index=0&id=a28cbe94&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a28cbe94"]])

export default __exports__